// GET VIEW DATA
export const GET_PRE_DATA = "app/PRE/GET_PRE_DATA";
export const GET_PRE_DATA_SUCCESS = "app/PRE/GET_PRE_DATA_SUCCESS";
export const GET_PRE_DATA_FAILURE = "app/PRE/GET_PRE_DATA_FAILURE";
// ADD
export const SAVE_PRE = "app/PRE/SAVE_PRE";
export const SAVE_PRE_SUCCESS = "app/PRE/SAVE_PRE_SUCCESS";
export const SAVE_PRE_FAILURE = "app/PRE/SAVE_PRE_FAILURE";
// TOGGLE MODAL
export const TOGGLE_PRE_MODAL = "app/PRE/TOGGLE_PRE_MODAL";
